<div class="h-100 align-items-center justify-content-center d-flex">
  <div class="modal-password-component">
    <div class="goback-btn" [hidden]="!showError">
      <mat-icon id="btn-password-go-back" class="icon-details" (click)="goBack()">arrow_back</mat-icon>
    </div>
    <div class="close-btn">
      <mat-icon id="btn-password-close" (click)="closeClick()" svgIcon="close"></mat-icon>
    </div>
    <div mat-dialog-title>
      <div *ngIf="showError" class="recover-error"></div><span
        [ngClass]="{ 'title-error' : showError }">{{ data.title }}</span>
    </div>
    <div mat-dialog-content>
      <div class="opacity-5">{{ data.content }}</div>
      <div [hidden]="showConfirm || showError">
        <form name="form" #loginForm="ngForm" novalidate>

          <div class="form-div" *ngIf="!isLoginWSO2">
            <mat-form-field class="userinput">
              <mat-icon svgIcon="user" matPrefix></mat-icon>
              <input matInput placeholder="{{placeHolder}}" autocomplete="username" name="username" #username="ngModel"
                required minlength="3" maxlength="255" [(ngModel)]="user" (keyup)="resetValidity($event)" email>
              <mat-icon *ngIf="username.touched && username.valid" matSuffix class="valid">done</mat-icon>
              <mat-icon *ngIf="username.touched && username.invalid" matSuffix class="invalid">clear</mat-icon>
              <mat-error *ngIf="username.touched && username.value == ''">Campo obrigatório</mat-error>
            </mat-form-field>
          </div>

          <div class="form-div" *ngIf="isLoginWSO2">
            <mat-form-field class="userinput">
              <mat-icon svgIcon="user" matPrefix></mat-icon>
              <input matInput placeholder="Usuário (CPF)" autocomplete="cpf" name="cpf" #cpf="ngModel" required
                minlength="3" maxlength="11" [(ngModel)]="user" (keyup)="maskLogin($event, user);"
                (paste)="maskLogin($event, user);">
              <mat-icon *ngIf="cpf.touched && cpf.valid" matSuffix class="valid">done</mat-icon>
              <mat-icon *ngIf="cpf.touched && cpf.invalid" matSuffix class="invalid">clear</mat-icon>
              <mat-error *ngIf="cpf.touched && cpf.value == ''">Campo obrigatório</mat-error>
            </mat-form-field>
          </div>
        </form>
      </div>
    </div>
    <div mat-dialog-actions>
      <div [hidden]="showError" class="button-submit">
        <div class="button-progress">

          <div [hidden]="showConfirm || showError">
            <div id="spinnerDiv" *ngIf="!isUserLogged && loading" [ngClass]="{ 'fadeIn': loading, 'fadeOut': !loading }"
              class="animated">
              <mat-spinner diameter="38" color="primary02"></mat-spinner>
            </div>
            <button
              id="btn-send-user"
              [ngClass]="{ 'fadeIn': !loading, 'fadeOut': loading, 'error': loginForm.form.invalid && loginForm.touched && !user , 'success': !loading && isUserLogged }"
              mat-raised-button color="primary01" class="animated" [disabled]="loading || loginForm.form.invalid"
              (click)="send(user)">
              Enviar <mat-icon matSuffix>arrow_forward</mat-icon>
            </button>
          </div>

          <div [hidden]="!showConfirm">
            <img src="./assets/images/svg/send.svg" width="97.2px" height="97.2px">
          </div>
        </div>
      </div>
      <div class="contact-error" [hidden]="!showError">
        <div class="box" *ngIf="optinsRecovever.helpPhone1 &&  optinsRecovever.helpPhone1.phoneNumber != ''">
          <div class="block-box"><img *ngIf="optinsRecovever.helpPhone1.isWhatsApp"
              src="./assets/images/svg/whatsapp-logo.svg" style="width: 29px;"></div>
          <span class="block-box contact-link"
            (click)="openWhatsappWindow()">{{ optinsRecovever.helpPhone1.phoneNumber }}</span>
        </div>
        <div class="box" *ngIf="optinsRecovever.helpEmail != ''">
          <div class="block-box"><img src="./assets/images/svg/email.svg" style="width: 29px;"></div>
          <a class="block-box contact-link" href="mailto:{{ optinsRecovever.helpEmail }}">{{ optinsRecovever.helpEmail }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
